import React, { Component } from 'react';
import Axios from 'axios';
import { API_HOST, axiosInstance } from '../../constants/server.constant';
import { axiosRequestWithAuth } from './../../constants/server.constant';
import { SessionService } from './../../services/session.service';
import ReactTooltip from 'react-tooltip';

export class PrintRecovery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            recoveryCode: "",
            accountName: "",
            userId: ""
        };


    }
    componentDidMount() {
        let userid = this.props.match.params.userId;
        this.setState({
            userId: userid
        });
        if(userid == localStorage.getItem("userId")) {
            axiosInstance.get(API_HOST + "/2fa/totp/printcode/" + userid, axiosRequestWithAuth).then(resp => {
                let info = resp.data.body;
                if(info.error === "false") {
                    this.setState({
                        recoveryCode: info.recoveryCode,
                        accountName: info.email
                    });
                    setTimeout(() => {
                        window.print();
                    }, 1000);
                }
            });
        }


    }

    render() {
        return (
            <body className="idcmp-frontend-main">
                <header>
                    <div className="idcmp-container">
                        {/* <a className="back_btn" data-tip data-for = "login" onClick = {()=>this.gotoLogin()}>
                            <span>
                                <svg x="0px" y="0px" width="50px" height="30px" viewBox="0 0 50 30" enableBackground="new 0 0 50 30" xmlSpace="preserve">
                                    <g>
                                        <path fill="#F3F3F3" d="M49,3.01v23.98C49,28.1,48.1,29,47,29H3c-1.1,0-2-0.9-2-2.01V3.01C1,1.9,1.9,1,3,1h44
                                            C48.1,1,49,1.9,49,3.01z"/>
                                        <path fill="#CCCCCB" d="M47,0H3C1.34,0,0,1.35,0,3.01v23.98C0,28.65,1.34,30,3,30h44c1.66,0,3-1.35,3-3.01V3.01
                                            C50,1.35,48.66,0,47,0z M49,26.99C49,28.1,48.1,29,47,29H3c-1.1,0-2-0.9-2-2.01V3.01C1,1.9,1.9,1,3,1h44c1.1,0,2,0.9,2,2.01V26.99z
                                            "/>
                                    </g>
                                    <polygon fill="#636363" points="33,10 33,15.99 23,16 23,21 17,15 23,9 23,14 31,14 31,10 "/>
                                </svg>
                            </span>
                        </a>
                        <ReactTooltip id = "login" place = "right" effect = "solid">Back to login page</ReactTooltip> */}
                        <div className="idcmp-logo">
                            <a href="https://www.idrivecompute.com/app/login"><img src="https://www.idrivecompute.com/webapp/images/computelogo_blue.svg" alt="IDrive Compute Logo" /></a>
                        </div>
                    </div>
                </header>
                <div className="idcmp-2fa-wrpr">
                    <div className="idcmp-2fa-blk">
                        <div className="idcmp-totp-wrapper">
                            <h2>Recovery Code
                                <a class="print" onClick={ () => window.print() }> <span class="pts_icon"></span> <span class="pts_title">Print</span></a>
                            </h2>
                            <div className="idcmp-totp-inner-wrap">
                                <p>If you do not have access to mobile device, you can disable two-factor authentication via Time-based OTP authentication by entering your 16-digit recovery code</p>
                                <em>{ this.state.recoveryCode }</em><label><span>Account:</span>{ this.state.accountName }</label><label style={ { display: "none" } }><span>Activation Date:</span>07/23/2021, Friday, 2:01:13 PM</label>
                                <p>Store your recovery code securely. In case you lose it, you will not be able to disable two-factor authentication via TOTP for your account.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <footer>
                    <p className="idcmp-copy">© IDrive Inc.</p>
                </footer>
            </body>
        );
    }
}